import { render, staticRenderFns } from "./DateformatDatepicker.vue?vue&type=template&id=08c4aa74"
import script from "./DateformatDatepicker.vue?vue&type=script&lang=js"
export * from "./DateformatDatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports